import React, { type ReactNode } from 'react';
import IconTile from 'components/rtmEnrollment/IconTile';
import type { EnrollmentIcon } from 'components/rtmEnrollment/enrollmentSteps';
import { getRtmEnrollmentStyles } from 'components/rtmEnrollment/rtmEnrollmentStyles';

type InfoRowProps = {
  icon: EnrollmentIcon;
  label: ReactNode;
  description: ReactNode;
};

export default function InfoRow({ icon, label, description }: InfoRowProps) {
  const styles = getRtmEnrollmentStyles();

  return (
    <div className={styles.space.infoRow}>
      <IconTile icon={icon} size="sm" />
      <div className={styles.space.infoRowContent}>
        <p className={styles.type.label}>{label}</p>
        <p className={styles.type.description}>{description}</p>
      </div>
    </div>
  );
}
